import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'react-bootstrap';

const ConfirmationModal = ({ show, onClose, onConfirm, title, children: content }) => (
  <Modal show={show} onHide={onClose}>
    <Modal.Header>
      <Modal.Title>
        {title}
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      {content}
    </Modal.Body>
    <Modal.Footer>
      <Button onClick={onClose}>
        Close
      </Button>
      <Button bsStyle="primary" onClick={onConfirm}>
        Continue
      </Button>
    </Modal.Footer>
  </Modal>
);

ConfirmationModal.defaultProps = {
  show: false,
  children: <div />,
};

ConfirmationModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  show: PropTypes.bool,
  title: PropTypes.string.isRequired,
  children: PropTypes.any,
};

export default ConfirmationModal;



/** WEBPACK FOOTER **
 ** ./src/components/common/Modals/ConfirmationModal/ConfirmationModal.jsx
 **/